import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';

export interface Payload {
  name: string;
  layoutType: LayoutType;
  tabId?: string | null;
}

export const removeSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType, tabId } = payload;
  const sections = state[layoutType].sections;

  if (sections.length === 1) {
    return;
  }

  state[layoutType].sections = sections.filter((section) => {
    if (section.name !== name) return true;

    if (tabId === undefined) return false;

    return (section.tabId ?? null) !== (tabId ?? null);
  });
};
